import { render } from "./initial_proposal.vue?vue&type=template&id=3187b0c9"
import script from "./initial_proposal.vue?vue&type=script&lang=js"
export * from "./initial_proposal.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/beta/web_head/releases/20260921234915/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__